import { useCallback, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import debounce from 'lodash.debounce';
import { CloseButton, useDisclosure, InputGroup, InputLeftElement, Input, InputRightElement } from "@chakra-ui/react";
import Modal from "components/modal/Modal";
import { FiSearch } from "react-icons/fi";
import { getByPage } from "./../../../store/features/slices/compraSlice";
import { uriSerialized } from "utils/uriSerialized";
import TablePagination from "./table/TablePagination";
import Spinner from "components/spinner/Spinner";
import InputField from "components/fields/InputField";
import TableCartItemsDetalles from "./table/TableCartItemsDetalles";

const Compras = () => {
    const dispatch = useDispatch();
    const {
        dataByPage,
        totalPage,
        totalRow,
        responseSuccessCreate,
        isLoading,
        responseSuccessDelete,
    } = useSelector((state) => state.compraReducer);

    const detalles = useDisclosure()
    const [searchTerm, setSearchTerm] = useState('');
    const [stateDetalles, setStateDetalles] = useState(null)

    function handleDetalles(row) {
        setStateDetalles(row)
        detalles.onOpen()
    }

    const fetchData = useCallback(
        (pageSize, pageIndex, search, order) => {
            const queryOptions = {
                page: pageIndex,
                limit: pageSize,
                search: search,
                order: order
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            dispatch(getByPage({ query: query }))
        },
        [responseSuccessDelete, responseSuccessCreate]
    )

    const onChangeSearchTerm = e => {
        setSearchTerm(e.target.value);
    };

    const onChangeSearchTermClear = e => {
        setSearchTerm("");
        document.getElementById("search").value = "";
    };

    const debounceSearchTerm = useMemo(() => debounce(onChangeSearchTerm, 700), []);

    return (
        <div className="mt-4 md:mt-0">
            <div className="sticky z-30 w-full top-44 md:top-28 flex items-center justify-end bg-white dark:!bg-navy-800 p-2 rounded-xl shadow-xl shadow-gray-200 dark:shadow-none">
                <div className="relative flex h-[61px] w-[calc(100%-55px)] flex-grow items-center gap-2 rounded-full bg-white px-0 py-2 dark:!bg-navy-800">
                    <InputGroup className="!w-full md:!w-[300px]">
                        <InputLeftElement pointerEvents="none" className="!mt-1 !ml-1">
                            <FiSearch size={24} className="text-navy-500 dark:text-navy-300" />
                        </InputLeftElement>
                        <Input size='lg' autoFocus id="search" onChange={debounceSearchTerm} type="text" placeholder={`Buscar ${totalRow} compras...`} className="flex w-full items-center justify-center !rounded-xl border !bg-lightPrimary 
            dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
            focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
            !outline-none !border-gray-200 dark:!border-white/10 dark:text-white" />
                        <InputRightElement className="!mt-1">
                            <CloseButton onClick={onChangeSearchTermClear} size='md' className={`mr-2 ${searchTerm.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-navy-500 dark:text-navy-300`} />
                        </InputRightElement>
                    </InputGroup>
                </div>
            </div>
            <div className="mt-3 md:mt-8">

                {/** DETALLES */}
                <Modal isOpen={detalles.isOpen} onClose={detalles.onClose} headerTitle='Detalles de la compra'>
                    {stateDetalles !== null &&
                        <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                            <form className="w-full">
                                <div className="flex flex-wrap">
                                    <InputField
                                        variant="input"
                                        iconleft={stateDetalles === null && <Spinner size="w-[25px] h-[25px]" />}
                                        disabled={true}
                                        extra="w-full md:w-4/12 mb-3 p-2"
                                        label="Proveedor"
                                        placeholder=""
                                        id="input"
                                        type="text"
                                        name="input"
                                        value={stateDetalles.proveedor.razon}
                                    />
                                    <div className="w-full grid grid-cols-1 mt-3">
                                        <TableCartItemsDetalles
                                            tableData={stateDetalles}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                </Modal>

                <div className="mt-5 grid h-full grid-cols-1">
                    <TablePagination
                        searchTerm={searchTerm}
                        tableData={dataByPage}
                        fetchData={fetchData}
                        loading={isLoading}
                        pageCount={totalPage}
                        totalRow={totalRow}
                        actions={{
                            onView: (item) => handleDetalles(item)
                        }}
                    />
                </div>
            </div>
        </div >

    );
};

export default Compras;
